"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoucherController = void 0;
const VoucherView_1 = require("./VoucherView");
const PromoPanelConfig_1 = require("../../config/PromoPanelConfig");
/**
 * Created by jonas on 2023-12-05.
 */
class VoucherController {
    get promotionPlugin() {
        return this._promotionPlugin;
    }
    get view() {
        return this._view;
    }
    constructor(promotionPlugin, id) {
        this._isOpen = false;
        this.id = id;
        this.config = PromoPanelConfig_1.PromoPanelConfig.getFeatureConfig(id);
        this._promotionPlugin = promotionPlugin;
        this._view = new VoucherView_1.VoucherView(this);
    }
    buttonClick(button, featureData, isManualCall) {
    }
    open() {
        if (this._view) {
            this._view.open();
            this._isOpen = true;
        }
    }
    close() {
        if (this._view) {
            this._isOpen = false;
            this._view.close();
        }
    }
}
exports.VoucherController = VoucherController;
//# sourceMappingURL=VoucherController.js.map